import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { QueryParam } from '~/common/types';
import { useLocationSearchParams } from '~/hooks';

export interface UseDataGridQueryBuilderToggleResult {
  show: boolean;
  onToggle: () => void;
}

export const useDataGridQueryBuilderToggle = (): UseDataGridQueryBuilderToggleResult => {
  const location = useLocation();
  const [{ [QueryParam.HIDE_QUERY_BUILDER]: hideQb }, setSearchParam] = useLocationSearchParams();

  const show = !hideQb;

  const onToggle = useCallback(() => {
    setSearchParam((prev) => ({ ...prev, hideQb: prev.hideQb ? null : true }), {
      pathname: location.pathname,
      replace: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return {
    show,
    onToggle,
  };
};
